import { render, staticRenderFns } from "./IMAGEDISPLAY.vue?vue&type=template&id=2505ae46&scoped=true&"
import script from "./IMAGEDISPLAY.vue?vue&type=script&lang=js&"
export * from "./IMAGEDISPLAY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505ae46",
  null
  
)

export default component.exports